import { supabase } from '@/lib/supabase/config';

export interface ProjectPlanUsageCounts {
  client_core_available: number;
  client_core_used: number;
  client_growth_available: number;
  client_growth_used: number;
  client_scale_available: number;
  client_scale_used: number;
}

export async function getProjectPlanUsageCounts(
  organizationId: number,
): Promise<ProjectPlanUsageCounts> {
  const { data, error } = await supabase.rpc('get_project_plan_usage_counts', {
    p_organization_id: organizationId,
  });

  if (error) {
    throw new Error(error.message || 'Failed to get project plan usage counts');
  }

  if (!data) {
    return {
      client_core_available: 0,
      client_core_used: 0,
      client_growth_available: 0,
      client_growth_used: 0,
      client_scale_available: 0,
      client_scale_used: 0,
    };
  }

  return {
    client_core_available: data.client_core_available ?? 0,
    client_core_used: data.client_core_used ?? 0,
    client_growth_available: data.client_growth_available ?? 0,
    client_growth_used: data.client_growth_used ?? 0,
    client_scale_available: data.client_scale_available ?? 0,
    client_scale_used: data.client_scale_used ?? 0,
  };
}
